import { defineMessages } from 'react-intl';

const scope = 'app.components.TapToTip.Setup.ToursSection';

export default defineMessages({
  status: {
    id: `${scope}.status`,
    defaultMessage: 'Status'
  },
  reviewLinks: {
    id: `${scope}.reviewLinks`,
    defaultMessage: 'Review links'
  },
  tour: {
    id: `${scope}.tour`,
    defaultMessage: 'Tour'
  },
  inviteGuides: {
    id: `${scope}.inviteGuides`,
    defaultMessage: 'Invite Guides'
  },
  manage: {
    id: `${scope}.manage`,
    defaultMessage: 'Manage'
  },
  createTour: {
    id: `${scope}.createTour`,
    defaultMessage: 'Create Tour'
  },
  editTour: {
    id: `${scope}.editTour`,
    defaultMessage: 'Edit Tour'
  },
  deleteTour: {
    id: `${scope}.deleteTour`,
    defaultMessage: 'Delete Tour'
  },
  tours: {
    id: `${scope}.tours`,
    defaultMessage: 'Tours'
  },
  confirm: {
    id: `${scope}.confirm`,
    defaultMessage: 'Confirm'
  },
  confirmAction: {
    id: `${scope}.confirmAction`,
    defaultMessage: 'Confirm action'
  },
  removeTourConfirm: {
    id: `${scope}.removeTourConfirm`,
    defaultMessage: 'Confirm that you wish to delete the tour'
  },
  emptyBodyTitle: {
    id: `${scope}.emptyBodyTitle`,
    defaultMessage: 'No Tours created yet'
  },
  emptyBodyDescription: {
    id: `${scope}.emptyBodyDescription`,
    defaultMessage: 'To start gathering reviews, set up tours here.'
  },
  description: {
    id: `${scope}.description`,
    defaultMessage: 'Setup and manage tours & their review links for your account'
  },
  searchLabel: {
    id: `${scope}.searchLabel`,
    defaultMessage: 'Search tours'
  },
  searchPlaceholder: {
    id: `${scope}.searchPlaceholder`,
    defaultMessage: 'Search by tour name or city'
  },
  statusFilterLabel: {
    id: `${scope}.statusFilterLabel`,
    defaultMessage: 'Filter by status'
  },
  allStatuses: {
    id: `${scope}.allStatuses`,
    defaultMessage: 'All statuses'
  },
  statusActive: {
    id: `${scope}.statusActive`,
    defaultMessage: 'Active'
  },
  statusIncomplete: {
    id: `${scope}.statusIncomplete`,
    defaultMessage: 'Incomplete'
  },
  cityFilterLabel: {
    id: `${scope}.cityFilterLabel`,
    defaultMessage: 'Filter by city'
  },
  allCities: {
    id: `${scope}.allCities`,
    defaultMessage: 'All cities'
  },
  countAll: {
    id: `${scope}.countAll`,
    defaultMessage: '{total, plural, one {# tour} other {# tours}}'
  },
  countFiltered: {
    id: `${scope}.countFiltered`,
    defaultMessage: 'Showing {shown} of {total} tours'
  },
  clearFilters: {
    id: `${scope}.clearFilters`,
    defaultMessage: 'Clear'
  },
  noMatchesTitle: {
    id: `${scope}.noMatchesTitle`,
    defaultMessage: 'No tours match'
  },
  noMatchesDescription: {
    id: `${scope}.noMatchesDescription`,
    defaultMessage: 'Try a different search, or clear the filters.'
  }
});
